import { useCallback } from 'react'
import {
  logUserAction,
  logCreate,
  logUpdate,
  logDelete,
  logView,
  type LogAction,
  type EntityType,
  type LogMetadata,
} from '../services/userLogs'

/**
 * Hook para facilitar o uso do serviço de logs
 */
export const useUserLogs = () => {
  const logAction = useCallback(
    async (
      action: LogAction,
      entityType: EntityType,
      entityId: string | null | undefined,
      description: string,
      metadata?: LogMetadata
    ) => {
      await logUserAction({
        action,
        entityType,
        entityId: entityId || null,
        description,
        metadata,
      })
    },
    []
  )

  const logCreateAction = useCallback(
    async (
      entityType: EntityType,
      entityId: string | null,
      description: string,
      metadata?: LogMetadata
    ) => {
      await logCreate(entityType, entityId, description, metadata)
    },
    []
  )

  const logUpdateAction = useCallback(
    async (
      entityType: EntityType,
      entityId: string | null,
      description: string,
      oldValues?: Record<string, any>,
      newValues?: Record<string, any>,
      additionalMetadata?: LogMetadata
    ) => {
      await logUpdate(entityType, entityId, description, oldValues, newValues, additionalMetadata)
    },
    []
  )

  const logDeleteAction = useCallback(
    async (
      entityType: EntityType,
      entityId: string | null,
      description: string,
      metadata?: LogMetadata
    ) => {
      await logDelete(entityType, entityId, description, metadata)
    },
    []
  )

  const logViewAction = useCallback(
    async (
      entityType: EntityType,
      entityId: string | null | undefined,
      description?: string
    ) => {
      await logView(entityType, entityId, description)
    },
    []
  )

  return {
    logAction,
    logCreate: logCreateAction,
    logUpdate: logUpdateAction,
    logDelete: logDeleteAction,
    logView: logViewAction,
  }
}
